<div class="companies-page preset-categories-page">
  <div class="companies-header">
    <div class="header-left">
      <h1>Preset Categories</h1>
      <p>
        Showing page {{ pageNumber }} of {{ totalPages || 1 }} 
        (Total {{ totalCount }} categories)
      </p>
    </div>

    <div class="header-right">
      <div class="search-box">
        <span class="search-icon">⌕</span>
        <input 
          type="text" 
          [value]="searchTerm" 
          (input)="onSearchChange($event)" 
          placeholder="Search..." 
        />
      </div>

      <div class="filter-group">
        <select class="status-select" [(ngModel)]="statusFilter" (change)="onStatusFilterChange()">
          <option value="All">All Statuses</option>
          <option value="Active">Active</option>
          <option value="Inactive">Inactive</option>
        </select>
      </div>

      <div class="filter-group">
        <select class="status-select page-size-select" [(ngModel)]="pageSize" (change)="onPageSizeChange()">
          <option [ngValue]="10">10 per page</option>
          <option [ngValue]="20">20 per page</option>
          <option [ngValue]="50">50 per page</option>
          <option [ngValue]="100">100 per page</option>
          <option [ngValue]="200">200 per page</option>
        </select>
      </div>

      <button type="button" class="create-btn" (click)="openCreateModal()">
        Create
      </button>
    </div>
  </div>

  @if (isLoading && categories.length === 0) {
    <div class="empty-state">Loading preset categories...</div>
  } @else {
    <div class="companies-table-card">
      <div class="table-scroll">
        <table class="companies-table preset-categories-table">
          <thead>
            <tr>
              <th>NAME</th>
              <th>DESCRIPTION</th>
              <th>STATUS</th>
              <th>ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            @for (category of categories; track category.presetCategoryId) {
              <tr>
                <td class="truncate-cell company-name font-semibold" style="font-weight: 600;">{{ category.name }}</td>
                <td class="truncate-cell" style="max-width: 400px;" title="{{ category.description }}">{{ category.description || '-' }}</td>
                <td>
                  <span class="status-badge" [class.active]="category.isActive">
                    {{ category.isActive ? 'Active' : 'Inactive' }}
                  </span>
                </td>
                <td>
                  <div class="action-buttons">
                    <button type="button" class="btn-edit" (click)="openEditModal(category)">
                      ✎ <span>Edit</span>
                    </button>
                    <button
                      type="button"
                      class="icon-action delete"
                      (click)="onDeleteCategory(category)"
                      [disabled]="category.presetCategoryId === 1 || deletingCategoryId === category.presetCategoryId"
                      [title]="category.presetCategoryId === 1 ? 'Uncategorized category cannot be deleted' : 'Delete'"
                    >
                      <img src="/icons/delete.svg" alt="Delete" class="action-icon" />
                    </button>
                  </div>
                </td>
              </tr>
            }
            @if (categories.length === 0) {
              <tr>
                <td colspan="5" class="text-center py-4">No preset categories found.</td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <!-- Pagination Controls -->
      <div class="pagination-controls">
        <button 
          type="button" 
          class="btn-pagination" 
          (click)="previousPage()" 
          [disabled]="pageNumber === 1 || isLoading">
          Previous
        </button>
        <span class="page-info">Page {{ pageNumber }} of {{ totalPages || 1 }}</span>
        <button 
          type="button" 
          class="btn-pagination" 
          (click)="nextPage()" 
          [disabled]="pageNumber >= totalPages || isLoading">
          Next
        </button>
      </div>
    </div>
  }

  @if (isModalOpen) {
    <div class="modal-overlay" (click)="closeModal()">
      <div class="company-modal" (click)="$event.stopPropagation()">
        <div class="modal-header">
          <div>
            <h2>{{ isEditMode ? 'Edit Preset Category' : 'Create New Preset Category' }}</h2>
            <p>
              {{
                isEditMode
                  ? 'Update preset category details.'
                  : 'Add a new preset category to the system.'
              }}
            </p>
          </div>
          <button type="button" class="close-btn" (click)="closeModal()">×</button>
        </div>

        <form [formGroup]="categoryForm" (ngSubmit)="saveCategory()" class="modal-form">
          <div class="form-grid one-col">
            <div class="form-field">
              <label>Name *</label>
              <input type="text" formControlName="name" placeholder="e.g. Portrait, Wedding" />
              @if (nameControl?.touched && nameControl?.errors?.['required']) {
                <div class="field-error">Name is required.</div>
              }
            </div>

            <div class="form-field">
              <label>Description</label>
              <textarea formControlName="description" rows="4" placeholder="Category description..." class="form-textarea"></textarea>
            </div>

            <div class="form-field checkbox-container">
              <label class="checkbox-label">
                <input type="checkbox" formControlName="isActive" />
                <span class="checkbox-text">Is Active</span>
              </label>
            </div>
          </div>

          <div class="modal-actions">
            <button type="button" class="btn-cancel" (click)="closeModal()">Cancel</button>
            <button type="submit" class="btn-save" [disabled]="isSaving || categoryForm.invalid">
              {{
                isSaving
                  ? isEditMode
                    ? 'Updating...'
                    : 'Creating...'
                  : isEditMode
                    ? 'Update Category'
                    : 'Create Category'
              }}
            </button>
          </div>
        </form>
      </div>
    </div>
  }

  <div class="companies-footer">
    <a href="javascript:void(0)">Privacy Policy</a>
    <a href="javascript:void(0)">Terms of Service</a>
    <a href="javascript:void(0)">Contact</a>
  </div>
</div>

@if (isDeleteModalOpen()) {
  <div class="modal-overlay" (click)="closeDeleteModal()">
    <div class="delete-modal" (click)="$event.stopPropagation()">
      <div class="delete-modal-header">
        <h3>Delete Preset Category</h3>
        <button type="button" class="modal-close-btn" (click)="closeDeleteModal()">×</button>
      </div>

      <div class="delete-modal-body">
        <p>
          Are you sure you want to delete the preset category
          <strong>{{ deletingCategory?.name }}</strong>?
        </p>
      </div>

      <div class="delete-modal-actions">
        <button type="button" class="delete-cancel-btn" (click)="closeDeleteModal()">Cancel</button>
        <button
          type="button"
          class="delete-confirm-btn"
          (click)="confirmDeleteCategory()"
          [disabled]="isDeleting"
        >
          {{ isDeleting ? 'Deleting...' : 'Delete' }}
        </button>
      </div>
    </div>
  </div>
}

@if (errorMessage) {
  <div class="global-error-overlay" (click)="clearError()">
    <div class="error-toast" (click)="$event.stopPropagation()">
      <div class="error-icon">
        <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
      </div>
      <div class="error-content">
        <h3>Something went wrong</h3>
        <p>{{ errorMessage }}</p>
        <div class="error-actions">
          <button type="button" class="btn-error-ok" (click)="clearError()">OK</button>
        </div>
      </div>
      <button type="button" class="close-toast-btn" (click)="clearError()">×</button>
    </div>
  </div>
}
